export default __webpack_public_path__ + "bf3c193b9da4a2defa97048c0802730f.svg";